import React from 'react';

import { withPermissionCheck } from 'redpoints-front-common/components';
import { PAGE_TYPE } from 'redpoints-front-common/config';
import {
  AssetVerification,
  AssetVerificationCard,
} from 'redpoints-front-asset-verification/AssetVerification';
import { ASSET_VERIFICATION_ROUTES } from 'redpoints-front-asset-verification/common/config/constants';
import { INFRINGEMENT_CONFIRMATION_ROUTES } from 'redpoints-front-infringement-confirmation/common/config/constants';
import {
  InfringementConfirmation,
  InfringementConfirmationCard,
} from 'redpoints-front-infringement-confirmation/InfringementConfirmation';
import { INFRINGEMENT_EVALUATION_ROUTES } from 'redpoints-front-infringement-evaluation/common';
import {
  InfringementEvaluation,
  InfringementEvaluationCard,
} from 'redpoints-front-infringement-evaluation/InfringementEvaluation';
import { JiraManagement } from 'redpoints-front-jira-management/JiraManagement';
import { MANUAL_ENFORCEMENT_ROUTES } from 'redpoints-front-manual-enforcement/common/config/constants';
import { ManualEnforcement } from 'redpoints-front-manual-enforcement/ManualEnforcement';
import {
  DataCompletion,
  DataCompletionLinkDetails,
  DataCompletionOnHold,
} from 'redpoints-front-data-completion/DataCompletion';
import { NewIncident } from 'redpoints-front-new-incident/NewIncident';
import { NOTICE_SENDING_ROUTES } from 'redpoints-front-notice-sending/common/config/constants';
import {
  NoticeSending,
  NoticeSendingCard,
} from 'redpoints-front-notice-sending/NoticeSending';

import { ROUTES } from './config/constants';
import ReportedIncidentsContainer from './containers/Tasks/ReportedIncidents/ReportedIncidents';
import { translate } from './helpers/languageHelper';
import AuditResults from './pages/AssetAudit/AuditResults/AuditResults';
import HomeDashboard from './pages/Home/HomeDashboard';
import HomeImpersonations from './pages/Home/HomeImpersonations';
import HomePiracy from './pages/Home/HomePiracy';
import AllIncidents from './pages/Reporting/AllIncidents/AllIncidents';
import IncidentDetails from './pages/Reporting/IncidentDetails/IncidentDetails';
import SocialMediaMessages from './pages/SocialMediaMessages/SocialMediaMessages';
import FacilitatorValidation from './pages/Tasks/FacilitatorValidation/FacilitatorValidation';
import ImageRecognition from './pages/Tasks/ImageRecognition/ImageRecognition';
import LinksManagement from './pages/Tasks/LinksManagement/LinksManagement';
import ShortenerResolution from './pages/Tasks/ShortenerResolution/ShortenerResolution';
import TestPurchase from './pages/Tasks/TestPurchase/TestPurchase';

const mainRoutes = [
  {
    path: ROUTES.HOME,
    title: translate('home.title'),
    component: HomeDashboard,
  },
  {
    path: ROUTES.HOME_PIRACY,
    title: translate('home_piracy.title'),
    component: HomePiracy,
  },
  {
    path: ROUTES.HOME_IMPERSONATIONS,
    title: translate('home_impersonations.title'),
    component: HomeImpersonations,
  },
  {
    path: ROUTES.NEW_INCIDENT,
    title: translate('new_incident.title'),
    component: NewIncident,
  },
  {
    path: ASSET_VERIFICATION_ROUTES.ASSET_VERIFICATION,
    title: translate('asset_verification.title'),
    exact: true,
    component: AssetVerification,
    pageType: PAGE_TYPE.GRID,
  },
  {
    path: ASSET_VERIFICATION_ROUTES.ASSET_VERIFICATION_DETAIL,
    title: translate('asset_verification.title'),
    exact: true,
    component: AssetVerificationCard,
  },
  {
    path: ASSET_VERIFICATION_ROUTES.ASSET_AUDIT_ASSET_VERIFICATION,
    title: `${translate('asset_verification.title')} `,
    exact: true,
    component: () => <AssetVerification isAudit />,
    pageType: PAGE_TYPE.GRID,
  },
  {
    path: ASSET_VERIFICATION_ROUTES.ASSET_AUDIT_ASSET_VERIFICATION_DETAIL,
    title: `${translate('asset_verification.title')} `,
    exact: true,
    component: AssetVerificationCard,
  },
  {
    path: INFRINGEMENT_EVALUATION_ROUTES.INFRINGEMENT_EVALUATION,
    title: translate('infringement_evaluation.title'),
    exact: true,
    component: InfringementEvaluation,
    pageType: PAGE_TYPE.GRID,
  },
  {
    path: INFRINGEMENT_EVALUATION_ROUTES.INFRINGEMENT_EVALUATION_DETAIL,
    title: translate('infringement_evaluation.title'),
    exact: true,
    component: InfringementEvaluationCard,
  },
  {
    path: INFRINGEMENT_EVALUATION_ROUTES.ASSET_AUDIT_INFRINGEMENT_EVALUATION,
    title: `${translate('infringement_evaluation.title')} `,
    exact: true,
    component: () => <InfringementEvaluation isAudit />,
    pageType: PAGE_TYPE.GRID,
  },
  {
    path:
      INFRINGEMENT_EVALUATION_ROUTES.ASSET_AUDIT_INFRINGEMENT_EVALUATION_DETAIL,
    title: `${translate('infringement_evaluation.title')} `,
    exact: true,
    component: InfringementEvaluationCard,
  },
  {
    path: INFRINGEMENT_CONFIRMATION_ROUTES.INFRINGEMENT_CONFIRMATION,
    title: translate('infringement_confirmation.title'),
    exact: true,
    component: InfringementConfirmation,
    pageType: PAGE_TYPE.GRID,
  },
  {
    path: INFRINGEMENT_CONFIRMATION_ROUTES.INFRINGEMENT_CONFIRMATION_DETAIL,
    title: translate('infringement_confirmation.title'),
    exact: true,
    component: InfringementConfirmationCard,
  },
  {
    path: NOTICE_SENDING_ROUTES.NOTICE_SENDING,
    title: translate('notice_sending.title'),
    exact: true,
    component: NoticeSending,
    pageType: PAGE_TYPE.GRID,
  },
  {
    path: NOTICE_SENDING_ROUTES.NOTICE_SENDING_DETAIL,
    title: translate('notice_sending.title'),
    exact: true,
    component: NoticeSendingCard,
  },
  {
    path: ROUTES.INCIDENTS_LIST,
    title: translate('reporting.allIncidentsCustomer.title'),
    component: AllIncidents,
  },
  {
    path: ROUTES.INCIDENTS_LIST_INTERNAL,
    title: translate('reporting.allIncidentsInternal.title'),
    component: AllIncidents,
  },
  {
    path: ROUTES.INCIDENT_DETAILS,
    title: translate('reporting.incidentDetails.title'),
    component: IncidentDetails,
  },
  {
    path: ROUTES.JIRA_MANAGEMENT,
    title: translate('reporting.jiraManagement.title'),
    component: JiraManagement,
  },
  {
    path: ASSET_VERIFICATION_ROUTES.ASSET_VERIFICATION_SOCIAL_MEDIA_MESSAGES,
    title: translate('social_media_messages.title'),
    component: SocialMediaMessages,
  },
  {
    path:
      INFRINGEMENT_EVALUATION_ROUTES.INFRINGEMENT_EVALUATION_SOCIAL_MEDIA_MESSAGES,
    title: translate('social_media_messages.title'),
    component: SocialMediaMessages,
  },
  {
    path:
      INFRINGEMENT_CONFIRMATION_ROUTES.SOCIAL_MEDIA_MESSAGES_INFRINGEMENT_CONFIRMATION,
    title: translate('social_media_messages.title'),
    component: SocialMediaMessages,
  },
  {
    path: NOTICE_SENDING_ROUTES.NOTICE_SENDING_SOCIAL_MEDIA_MESSAGES,
    title: translate('social_media_messages.title'),
    component: SocialMediaMessages,
  },
  {
    path: ROUTES.SHORTENER_RESOLUTION,
    title: translate('tasks.shortenerResolution.title'),
    component: ShortenerResolution,
  },
  {
    path: ROUTES.DATA_COMPLETION,
    title: translate('tasks.dataCompletion.title'),
    component: DataCompletion,
    exact: true,
  },
  {
    path: ROUTES.DATA_COMPLETION_ON_HOLD,
    component: DataCompletionOnHold,
    exact: true,
  },
  {
    path: ROUTES.DATA_COMPLETION_ON_HOLD_DETAILS,
    component: DataCompletionLinkDetails,
    exact: true,
  },
  {
    path: ROUTES.TEST_PURCHASE,
    title: translate('tasks.testPurchase.title'),
    component: TestPurchase,
  },
  {
    path: MANUAL_ENFORCEMENT_ROUTES.MANUAL_ENFORCEMENT,
    title: translate('tasks.manualEnforcement.title'),
    component: ManualEnforcement,
  },
  {
    path: ROUTES.IMAGE_RECOGNTION,
    title: translate('tasks.image_recognition.title'),
    component: ImageRecognition,
  },
  {
    path: ROUTES.REPORTED_INCIDENTS,
    title: translate('tasks.reported_incidents.title'),
    component: ReportedIncidentsContainer,
  },
  {
    path: ROUTES.LINKS_MANAGEMENT,
    title: translate('tasks.links_management.title'),
    component: LinksManagement,
  },
  {
    path: ROUTES.FACILITATOR_VALIDATION,
    title: translate('tasks.facilitatorValidation.title'),
    component: FacilitatorValidation,
  },
  {
    path: ROUTES.AUDIT_RESULTS,
    title: translate('auditResults.title'),
    component: AuditResults,
  },
  {
    path: ROUTES.ASSET_AUDIT_NEW_INCIDENT,
    title: `${translate('new_incident.title')} `,
    component: () => <NewIncident isAudit />,
  },
].map(el => ({ ...el, component: withPermissionCheck(el.component) }));

export default mainRoutes;
